// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgPin24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.6547 5.37405C16.6547 4.61518 16.0396 4 15.2807 4H8.41046C7.6516 4 7.03642 4.61518 7.03642 5.37405L7.03634 12.2209L5.13739 15.0863C5.04779 15.2214 5 15.3799 5 15.542C5 15.9973 5.36911 16.3664 5.82443 16.3664H11.0458V21.1756C11.0458 21.6309 11.4149 22 11.8702 22C12.3255 22 12.6947 21.6309 12.6947 21.1756V16.3664H17.8702C18.3256 16.3664 18.6947 15.9973 18.6947 15.542L18.6859 15.4218C18.6683 15.3029 18.6249 15.1887 18.5582 15.0876L16.6547 12.2058L16.6547 5.37405ZM8.6853 5.64872H15.0059L15.0059 12.7011L16.3374 14.7174H7.35935L8.68529 12.7176L8.6853 5.64872Z"
			/>
		</Svg>
	);
});
SvgPin24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgPin24;
